__turbopack_context__.v({
  "heading": "IV3FPG_heading",
  "wrapper": "IV3FPG_wrapper",
});
